export const types = {
  CLOSE: 'common/drawers/managedIntegrationsDrawer/CLOSE',
  OPEN: 'common/drawers/managedIntegrationsDrawer/OPEN',
  REFRESH_ACTIONS: 'common/drawers/managedIntegrationsDrawer/REFRESH_ACTIONS',
  REFRESH_ACTIONS_FINISHED:
    'common/drawers/managedIntegrationsDrawer/REFRESH_ACTIONS_FINISHED',
};

export const managedIntegrationDrawer = {
  close: () => ({
    type: types.CLOSE,
  }),
  open: ({
    defaultStatusIn = null,
    defaultTypeIn = null,
    managedIntegrationUuid,
    relatedObjectType = undefined,
    defaultRequestTab = undefined,
    selectedOrder = null,
    selectedQuote = undefined,
  }) => ({
    type: types.OPEN,
    payload: {
      defaultStatusIn,
      defaultTypeIn,
      managedIntegrationUuid,
      relatedObjectType,
      defaultRequestTab,
      selectedOrder,
      selectedQuote,
    },
  }),
  refreshActions: () => ({
    type: types.REFRESH_ACTIONS,
  }),
  refreshActionsFinished: () => ({
    type: types.REFRESH_ACTIONS_FINISHED,
  }),
};
